import { formatDate } from "utils/date";
import { unixTimestampToMs } from "utils/time";

export const makeTimestampToCopy = (rawTimestamp: number) => {
  return formatDate({ date: unixTimestampToMs(rawTimestamp) });
};
